import './App.css';
import Weatherbox from './components/Weatherbox';

function App() {
  return (
    <>
  <Weatherbox/>
    </>
  );
}

export default App;
